<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter">
            <el-form-item label="状态：">
                <el-select v-model="searchForm.disposeState" clearable>
                    <el-option value="1" label="待处理"></el-option>
                    <el-option value="2" label="已处理"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model="searchForm.iccid" @keyup.enter.native="getFeedbackListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="提交时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getFeedbackListPageHandle">搜索查询</el-button>
                <!-- <el-button type="primary">导入问题Excel</el-button> -->
                <el-button type="success" @click="exportFeedbackHandle">导出Excel</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >    
            <el-table-column prop="id" label="问题ID"></el-table-column>
            <el-table-column label="ICCID号" width="160">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="agencyName" label="名称"></el-table-column>
            <el-table-column prop="typeName" label="类型"></el-table-column>
            <el-table-column prop="problemContent" label="问题描述"></el-table-column>
            <el-table-column prop="currentTime" label="提交时间"></el-table-column>
            <el-table-column prop="disposeTime" label="处理时间"></el-table-column>
            <el-table-column prop="disposeNickName" label="处理人"></el-table-column>            
            <el-table-column label="处理状态">
                <template slot-scope="scope">
                    {{ scope.row.disposeState == 1 ? '待处理' : '已处理' }}
                </template>
            </el-table-column>            
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="showFeedbackHandle(scope.row)">{{ scope.row.disposeState == 1 ? '卡务操作' : '查看' }}</el-button>
                    <el-button type="text" @click="deleteFeedbackHandle(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :append-to-body="true"  title="解决反馈问题" :visible.sync="solutionVisibale" width="600px" :close-on-click-modal="false">
            <div>
                <div class="lineInDialog">
                    <label>ICCID号:</label>
                    <span>{{feedbackDetail.iccid}}</span>
                </div>
                <div class="lineInDialog">
                    <label>描述:</label>
                    <span>{{feedbackDetail.problemContent}}</span>
                </div>
                <div class="lineInDialog">
                    <label>处理方案:</label>
                    <el-input v-model="feedbackDetail.remark" type="textarea" rows="4" :disabled="remarkDisabled"></el-input>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureSolutionHandle">确 定</el-button>
            </div>   
        </el-dialog>              
    </div>
</template>
<script>
import {getFeedbackListPage, deleteFeedback, replayFeedback, exportFeedback} from '@/api/system.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                disposeState: '',
                iccid: '',
                time: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            solutionVisibale: false, 
            feedbackDetail: {
                id: '',
                iccid: '',
                problemType: '',
                problemContent: '',
                remark: ''
            },  
            remarkDisabled: false, 
            currentId: ''         
        }
    },
    methods: {
        cancel(){
            this.feedbackDetail.remark = '';
            this.solutionVisibale = false;
        },
        exportFeedbackHandle(){
            window.location.href='problemOrOrder/readExcels'
        },
        getFeedbackListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  

            getFeedbackListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showFeedbackHandle(row){
            this.solutionVisibale = true;            
            if(row.disposeState == 2){
                this.remarkDisabled = true;
            }else{
                this.remarkDisabled = false;
            }
            for(var key in this.feedbackDetail){
                this.feedbackDetail[key] = row[key];
            }
        },
        sureSolutionHandle(){
            var data = {
                id: this.feedbackDetail.id,
                remark: this.feedbackDetail.remark
            };
            replayFeedback(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.solutionVisibale = false;
                    this.getFeedbackListPageHandle();
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        deleteFeedbackHandle(id){
            this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteFeedback({id}).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getFeedbackListPageHandle();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(() => {

            })
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getFeedbackListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getFeedbackListPageHandle();
        }  
    },
    created () {
        this.getFeedbackListPageHandle()
    }  
}
</script>
<style lang="less" scoped>

</style>

